import PropTypes from "prop-types";
import Carousel from "nuka-carousel";

import { SliderStyled, Button, PrevIcon, NextIcon } from "./Slider.styled";

function Slider({
    isLoading,
    items,
    slideWidth,
    noButtonsMobile,
    noButtonsDesktop,
    overflowVisible,
    infinite
}) {
    return items && items.length > 0 ? (
        <SliderStyled
            isLoading={isLoading}
            noButtonsMobile={noButtonsMobile}
            noButtonsDesktop={noButtonsDesktop}
            overflowVisible={overflowVisible}
        >
            <Carousel
                cellSpacing={slideWidth === 1 ? 0 : 10}
                defaultControlsConfig={{
                    pagingDotsContainerClassName:
                        "slider-dots-container-custom",
                    pagingDotsClassName: "slider-dots-dot-custom"
                }}
                easing="easeSin"
                slideWidth={slideWidth}
                speed={300}
                swiping
                wrapAround={infinite}
                width="100%"
                vertical={false}
                frameOverflow={overflowVisible ? "visible" : "hidden"}
                getControlsContainerStyles={key => {
                    switch (key) {
                        case "BottomCenter":
                            return {
                                bottom: "-50px"
                            };
                        default:
                            return "";
                    }
                }}
                renderCenterLeftControls={null}
                renderBottomLeftControls={({ previousSlide, currentSlide }) =>
                    noButtonsMobile && noButtonsDesktop ? null : (
                        <Button
                            type="button"
                            aria-label="Vorige item"
                            left
                            onClick={previousSlide}
                            disabled={
                                isLoading || (!infinite && currentSlide === 0)
                            }
                        >
                            <PrevIcon
                                src="/images/icon-arrow-long-left.svg"
                                alt=""
                                loading="lazy"
                                width="56px"
                                height="30px"
                            />
                        </Button>
                    )
                }
                renderCenterRightControls={null}
                renderBottomRightControls={({
                    nextSlide,
                    currentSlide,
                    slideCount
                }) =>
                    noButtonsMobile && noButtonsDesktop ? null : (
                        <Button
                            type="button"
                            aria-label="Volgende item"
                            right
                            onClick={nextSlide}
                            disabled={
                                isLoading ||
                                (!infinite && currentSlide === slideCount - 1)
                            }
                        >
                            <NextIcon
                                src="/images/icon-arrow-long-right.svg"
                                alt=""
                                loading="lazy"
                                width="56"
                                height="30"
                            />
                        </Button>
                    )
                }
            >
                {items}
            </Carousel>
        </SliderStyled>
    ) : null;
}

Slider.propTypes = {
    isLoading: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    slideWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    noButtonsMobile: PropTypes.bool,
    noButtonsDesktop: PropTypes.bool,
    overflowVisible: PropTypes.bool,
    infinite: PropTypes.bool
};

Slider.defaultProps = {
    isLoading: false,
    items: [],
    slideWidth: "240px",
    noButtonsMobile: false,
    noButtonsDesktop: false,
    overflowVisible: false,
    infinite: false
};

export default Slider;
